"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initShadowRootsController = void 0;
const trackers_1 = require("./trackers");
const initShadowRootsController = (configuration, scope, callback, elementsScrollPositions) => {
    const controllerByShadowRoot = new Map();
    const shadowRootsController = {
        addShadowRoot: (shadowRoot) => {
            if (controllerByShadowRoot.has(shadowRoot)) {
                return;
            }
            const mutationTracker = (0, trackers_1.trackMutation)(callback, configuration, scope, shadowRootsController, shadowRoot);
            // The change event does not bubble up across the shadow root, we have to listen on the shadow root
            const inputTracker = (0, trackers_1.trackInput)(configuration, scope, callback, shadowRoot);
            // The scroll event does not bubble up across the shadow root, we have to listen on the shadow root
            const scrollTracker = (0, trackers_1.trackScroll)(configuration, scope, callback, elementsScrollPositions, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: () => mutationTracker.flush(),
                stop: () => {
                    mutationTracker.stop();
                    inputTracker.stop();
                    scrollTracker.stop();
                },
            });
        },
        removeShadowRoot: (shadowRoot) => {
            const entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: () => {
            controllerByShadowRoot.forEach(({ stop }) => stop());
        },
        flush: () => {
            controllerByShadowRoot.forEach(({ flush }) => flush());
        },
    };
    return shadowRootsController;
};
exports.initShadowRootsController = initShadowRootsController;
//# sourceMappingURL=shadowRootsController.js.map